import { PrescriptionSection } from '../components';

export function PrescriptionPages() {
  return <PrescriptionSection />;
}
